<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros style="width: 400px;"
    [name]="'filtros.per' | translate"
    [array]="Periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>
  <!--Filtro indicadores-->
  <div filtros style="width: 500px; margin-left: 100px; margin-top: 15px;">
    <div class="w3-veinte">
      <button class="w3-button w3-right" [matMenuTriggerFor]="menuIndicNiv1">
        {{ 'filtros.ind' | translate }}
        <mat-icon class="iconoMen">expand_more</mat-icon>
      </button>
      <mat-menu class="w3-medium" #menuIndicNiv1="matMenu">
        @for (indic of dataIndicadores; track $index) {
          <button mat-menu-item [matMenuTriggerFor]="menuIndicNiv2" (click)="desactivarIndicadores(indic); $event.stopPropagation();">
            <div class="w3-row" style="width: 9vw !important;">
              <div class="w3-quarter" style="padding-top: 3px;">
                <input type="checkbox" style="cursor: pointer;"
                [checked]="indic.check"/>
              </div>
              <div class="w3-rest textoOverFlow" matTooltip="{{indic.descripcion}}" matTooltipPosition="above" matTooltipShowDelay="1000">
                <span>{{indic.descripcion}}</span>
              </div>
            </div>
          </button>
          <mat-menu class="w3-medium" #menuIndicNiv2="matMenu">
            @for (indic2 of indic.series; track $index) {
              @if (indic2.series.length === 0) {
                <button mat-menu-item (click)="desactivarIndicadores(indic2); $event.stopPropagation();" class="textoOverFlow">
                  <div class="w3-row" style="width: 9vw !important;">
                    <div class="w3-quarter" style="padding-top: 3px;">
                      <input type="checkbox" style="cursor: pointer;"
                          [checked]="indic2.check"/>
                    </div>
                    <div class="w3-rest textoOverFlow" matTooltip="{{indic2.descripcion}}" matTooltipPosition="above"
                    matTooltipShowDelay="1000" style="text-align: left;">
                      {{indic2.descripcion}}
                    </div>
                  </div>
                </button>
              }@else {
                <button mat-menu-item [matMenuTriggerFor]="menuIndicNiv3" (click)="desactivarIndicadores(indic2); $event.stopPropagation();">
                  <div class="w3-quarter" style="padding-top: 3px;">
                    <input type="checkbox" [id]="'check_'+indic2.description" style="cursor: pointer;"
                    [checked]="indic2.check">
                  </div>
                  <div class="w3-rest textoOverFlow" matTooltip="{{indic2.Descripcion}}" matTooltipPosition="above" matTooltipShowDelay="1000">
                    <span>{{indic2.Descripcion}}</span>
                  </div>
                </button>
              }
              <mat-menu class="w3-medium" #menuIndicNiv3="matMenu">
                @for (indic3 of indic2.series; track $index) {
                  <button class="mat-menu-item" mat-menu-item (click)="desactivarIndicadores(indic3); $event.stopPropagation();">
                    <div class="w3-quarter" style="padding-top: 3px;">
                      <input type="checkbox" [id]="'check_'+indic3.description" style="cursor: pointer;"
                      [checked]="indic3.check">
                    </div>
                    <div class="w3-rest textoOverFlow" matTooltip="{{indic3.descripcion}}" matTooltipPosition="above" matTooltipShowDelay="1000">
                      <span>{{indic3.descripcion}}</span>
                    </div>
                  </button>
                }
              </mat-menu>
            }
          </mat-menu>
        }
      </mat-menu>
    </div>
    <div class="w3-rest">
      <div class="w3-row containerChips2">
        <div class="chips2 nombres2">
          <div class="autoAjuste2">
            @for (ind of dataIndicadores; track $index) {
              <div [ngClass]="{
                'w3-round-btn-large grisBtn w3-center w3-elemento-menu w3-button':ind.check,
                'w3-hide':!ind.check}" class="filtroMesAnioSeleccionado2">
                <span style="margin-left: 5px;">{{ind.descripcion}}</span>
              </div>
            }
          </div>
        </div>
        @if (numPerSelect()) {
          <div class="tresPuntos2">
            <mat-icon [ngStyle]="{'color':'gray'}" class="iconoClos w3-button"
            [matMenuTriggerFor]="menuDesplegable">more_horiz</mat-icon>
            <mat-menu #menuDesplegable="matMenu" xPosition="before">
              @for (ind of dataIndicadores; track $index) {
                <div  [ngClass]="{
                'w3-round-btn-large grisBtn w3-center w3-elemento-menu w3-button':ind.check,
                'w3-hide':!ind.check}" class="filtroMesAnioSeleccionado2">
                  <span style="margin-left: 5px;">{{ind.descripcion}}</span>
                </div>
              }
            </mat-menu>
          </div>
        }
      </div>
    </div>    
  </div>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="w3-row" [ngClass]="{'w3-white':visibleTabla,'w3-grey-fon':visibleTarjeta}">
      <div class="w3-titulo-contenidomenuSC" [ngClass]="{'headers':visibleTabla,'headersTransparent':visibleTarjeta}">
        <div class="w3-setenta">
          <span class="w3-margin-left-contenido">{{ 'financiero.razonesFinancieras.tituloEncabezadoTabla' | translate }}</span>
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">
            @for (per of subTitles; track $index) {
              <span style="margin-left: 5px;">{{escrituraPer(per)}}</span>
            }
          </span>
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menuGrafPrincipal">
            more_vert
          </mat-icon>
          <mat-menu #menuGrafPrincipal="matMenu">
            @if (visibleTarjeta) {
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="changeGrafic1('tab')">
                <mat-icon [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
                <span>{{'financiero.razonesFinancieras.tooltipIcono1'|translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarGraf('tarjets', 'financiero.razonesFinancieras.tituloEncabezadoTabla')">
                <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>
            }
            @if (visibleTabla) {
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="changeGrafic1('tar')">
                <mat-icon [ngStyle]="{'color':'gray'}">subtitles</mat-icon>
                <span>{{'financiero.razonesFinancieras.tooltipIcono8'|translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportExcel()">
                <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                <span>{{'menu.Exportar'|translate}}</span>
              </button>
            }
          </mat-menu>
          <mat-menu #menuTable="matMenu">
            <button  class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="changeGrafic1('tar')">
              <mat-icon [ngStyle]="{'color':'gray'}">subtitles</mat-icon>
              <span>{{'financiero.razonesFinancieras.tooltipIcono8'|translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="w3-row containerAll">
      @if (visibleTabla) {
        <div class="w3-row w3-scroll" style="height: 48vh;">
          @if(dataOrdenado.length > 0){
            <table class="w3-table borderInfLow">
              <thead>
                <tr class="w3-center w3-table-title">
                  @for (head of headersCheck; track head; let i = $index) {
                    @if (head.check && i===0) {
                      <th [ngClass]="{ 'w3-center': i!==0}" class="stikyColum ">
                        <span class="w3-elemento-titulo-table"> {{'financiero.razonesFinancieras.titulo'+(i+1)+'Tabla' | translate}} </span>
                      </th>
                    }
                  }
                  <th class="stikyColum w3-border-right-balance" >
                    @if (existeOcult()) {
                      <mat-icon class="iconoMen" [ngStyle]="{'color':'grey'}" style="font-weight: bold; margin-left: -30%; cursor: pointer;"
                      (click)="mostrarTodos()" fontSet="material-icons-outlined" matTooltip="Mostrar parámetros">visibility</mat-icon>  
                    }@else {
                      <mat-icon class="iconoMen"[ngStyle]="{'color':'grey'}" style="font-weight: bold; margin-left: -30%; cursor: pointer;"
                      (click)="ocultarTodos()" fontSet="material-icons-outlined" matTooltip="Mostrar parámetros">visibility_off</mat-icon>  
                    }
                  </th>
                  @for (head of headersCheck; track head; let i = $index) {
                    @if (head.check && i!==0 && !dataOrdenado[1]['formula'+i].includes('undefined')) {
                      <th [ngClass]="{ 'w3-center': i!==0 }" class="stikyColum w3-border-right-balance borde-semaforo"
                        [style.--color-semaforo]="head.color">
                        <span class="w3-elemento-titulo-table">
                          {{'financiero.razonesFinancieras.titulo'+(i+1)+'Tabla' | translate}}
                        </span>
                      </th>
                    }
                  }
                  @for (per of cadenaEvaluacion; track $index) {
                    <th class="w3-center stikyColum w3-border-right-balance">
                      <span class="w3-elemento-titulo-table"> {{escrituraPer(per.periodo)}} </span>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (item of dataOrdenado; track item; let i = $index) {
                  @if (item.check || verTitulos(i)) {
                    <tr class="w3-table-trtd">
                      <td class="borderInfLow">
                        @if (searchSubNivel(item, i)) {
                          <mat-icon (click)="showHideTab(item, i)" class="iconoMen w3-button">
                            {{dataOrdenado[i+1].check?'expand_less':'expand_more'}}
                          </mat-icon>
                        }@else{
                          <mat-icon class="iconoMen w3-button" style="cursor: default;"></mat-icon>
                        }
                        <span [ngClass]="{
                            'w3-elemento-tableIndicador w3-margin-lelf-1roIndicador': item.nivel===1,
                            'w3-elemento-tableIndicador w3-margin-lelf-2doIndicador': item.nivel===2,
                            'w3-elemento-tableIndicador w3-margin-lelf-3roIndicador': item.nivel===3
                          }" matTooltip="{{item.comentario}}" matTooltipPosition="right">
                            {{item.descripcion}}
                        </span>
                      </td>
                      <td class="borderInfLow"></td>
                      @for (head of headersCheck; track head; let h = $index) {
                        @if(head.check && h !== 0 && item.nivel !== 1 && !item['formula'+(h)].includes('undefined') ){
                          <td class="w3-center borderAllLow">
                            <span class="w3-elemento-tableIndicador">{{ item['formula'+(h)] }} </span>
                          </td>
                        }@else if (head.check && h !== 0 && item.nivel === 1 && !item['formula'+(h)].includes('undefined')) {
                          <td class="w3-center borderAllLow">
                            <br>
                          </td>
                        }
                      }
          
                      @for (per of item.series; track $index) {
                        <td class="borderAllLow">
                          <div [ngClass]="{
                            'w3-border-verde':(per.textoSemaforo==='V' || per.textoSemaforo==='V+')&&item.nivel !== 1,
                            'w3-border-rojo':per.textoSemaforo==='R'&&item.nivel !== 1,
                            'w3-border-naranja':per.textoSemaforo==='A-'&&item.nivel !== 1,
                            'w3-border-amarillo':per.textoSemaforo==='A+' && item.nivel !== 1 || per.textoSemaforo==='A'&&item.nivel !== 1
                          }" class="alinRight">
                            @if (item.nivel !== 1) {
                              <span class="w3-elemento-tableIndicador" style="margin-right: 1vh;">{{per.valor}}</span>
                            }@else {
                              <span class="w3-elemento-tableIndicador" style="margin-right: 1vh;"></span>
                            }
                          </div>
                        </td>
                      }
                    </tr>
                  }
                }
              </tbody>
            </table>  
          }@else {<app-skeleton-table [columnas]="5" [filas]="10"/>}          
        </div>
      }
      @if (visibleTarjeta) {
        <div class="w3-row w3-scroll" style="height: 44vh;">
          <div id="tarjets" class="w3-row">
            <div class="w3-row w3-grey-fon">
              @for (ind of dataIndicadores; track ind; let i = $index) {
                @if (ind.check) {
                  <div class="w3-row" style="margin-top: 1vh;">
                    @if (i !== 0) { <div style="height: 2vh;"></div> }
                    <span class="w3-margin-left-contenidotot w3-titulo-titulotarjetas">
                      {{ind.descripcion}}
                    </span>
                  </div>
                }
                @for (indN1 of ind.series; track $index) {
                  @if (indN1.check) {
                    <div class="veinticinco" style="margin-top: 1vh;">
                      @if (indN1.series.length !== 0) {
                        <span class="w3-margin-left-contenidotot w3-titulo-contenidotarjetas">
                          {{indN1.descripcion}}
                        </span>
                      }
                      @if (indN1.series.length === 0) {
                        @if (indN1.check) {
                          <div class="w3-row" style="margin-top: 1vh;">
                            <div [ngClass]="{
                              'w3-green':indN1.textoSemaforo==='V' || indN1.textoSemaforo==='V+',
                              'w3-yellow':indN1.textoSemaforo==='A+'||indN1.textoSemaforo==='A',
                              'w3-orange':indN1.textoSemaforo==='A-',
                              'w3-red':indN1.textoSemaforo==='R'
                            }" class="w3-col lineaColor"></div>
                            <div class="w3-col w3-container zonaTarjeta">
                              <div class="w3-half nombreTarjeta"> 
                                <span class="textoTarjeta" style="cursor: pointer;" (click)="graficaModal(indN1)" matTooltip="{{indN1.descripcion}}"> {{indN1.descripcion}} </span>
                              </div>
                              <div class="w3-rest w3-right zonaValor">
                                <span [ngClass]="{
                                  'greenText':indN1.textoSemaforo==='V' || indN1.textoSemaforo==='V+',
                                  'yellowText':indN1.textoSemaforo==='A+'||indN1.textoSemaforo==='A',
                                  'orangeText':indN1.textoSemaforo==='A-',
                                  'redText':indN1.textoSemaforo==='R'
                                }" class="valorTarjeta">{{indN1.valor}}</span>
                              </div>
                            </div>
                          </div>
                        }
                      }
                      @for (indN2 of indN1.series; track $index) {
                        @if (indN2.check) {
                          <div class="w3-row" style="margin-top: 1vh;">
                            <div [ngClass]="{
                              'w3-green':indN2.textoSemaforo==='V' || indN2.textoSemaforo==='V+',
                              'w3-yellow':indN2.textoSemaforo==='A+',
                              'w3-orange':indN2.textoSemaforo==='A-',
                              'w3-red':indN2.textoSemaforo==='R'
                            }" class="w3-col lineaColor"></div>
                            <div class="w3-col w3-container zonaTarjeta">
                              <div class="w3-half nombreTarjeta"> 
                                <span class="textoTarjeta" matTooltip="{{indN2.descripcion}}"> {{indN2.descripcion}} </span>
                              </div>
                              <div class="w3-rest w3-right zonaValor">
                                <span [ngClass]="{
                                  'greenText':indN2.textoSemaforo==='V' || indN2.textoSemaforo==='V+',
                                  'yellowText':indN2.textoSemaforo==='A+',
                                  'orangeText':indN2.textoSemaforo==='A-',
                                  'redText':indN2.textoSemaforo==='R'
                                }" class="valorTarjeta">{{indN2.valor}}</span>
                              </div>
                            </div>
                          </div>
                        }
                      }
                    </div>
                  }
                }
              }
            </div>
          </div>
        </div>
      }
      <div class="w3-row" style="height: 0.5vh;"></div>
      @if (visibleTabla) {
        <div class="w3-row" id="conteGrafica" style="height: 32vh;">
          <div class="w3-row" style="background-color: white;">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-half">
                <span class="w3-margin-left-contenido">{{ 'financiero.razonesFinancieras.tituloEncabezadoTabla2' | translate }}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitlesGraf)}}</span>
              </div>
              <div class="w3-rest w3-right">
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="openModal('graf1')" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                  zoom_out_map
                </mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafPrincipalGraf">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafPrincipalGraf="matMenu">
                  <!-- <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menuGraficas">
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.razonesFinancieras.tooltipIcono3'|translate}}</span>
                  </button> -->
                  <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGraf(0)">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar' | translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
          <div class="w3-row" style="height: 88%; background-color: white;">
            @if (dataGraficas.length > 0) {
              <app-graficador 
                  [etiquetas]="true"
                  [data]="dataGraficas"
                  [labels]="etiquetas"
                  [type]="tipo"
                  [axisX]="''"
                  [axisY]="['']"
                  [zona]="0"
                  [colors]="colorSchemeSem"
                  [formatEtiquetas]="false"
                  [legend]="{enabled: false, position: 'bottom'}"
                  [animations]="true"
                  [hetamapValor]="true"
                  (eventClick)="mostrarColores($event)">                  
                </app-graficador>
            }@else{<app-skeleton-grafica/> }
          </div>
        </div>
      }
      @if (visibleTarjeta) {
        <div class="w3-row" style="height: 40vh;">
          <div class="w3-row" style="background-color: white;">
            <div class="headers w3-titulo-contenidomenuSC">
              <div class="w3-half">
                <span class="w3-margin-left-contenido"> {{'financiero.razonesFinancieras.tituloZona2Graf'|translate}} | {{ indSeleccionado.descripcion }}</span>
                <span class="w3-margin-left-contenido">&bull;</span>
                <span class="w3-margin-left-filter w3-subtitulo">{{subTitlesGrafI}}</span>
              </div>
              <div class="w3-rest w3-right">
                <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="showLabelsEvo = !showLabelsEvo" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
                  {{ showLabelsEvo ? 'label_off' : 'label' }}
                </mat-icon> 
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                (click)="openModal('graf2')" matTooltip="{{'financiero.catalogoCuentas.tooltipIcono2'|translate}}">
                  zoom_out_map
                </mat-icon>
                <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
                [matMenuTriggerFor]="menuGrafPrincipalTarjetas">
                  more_vert
                </mat-icon>
                <mat-menu #menuGrafPrincipalTarjetas="matMenu">
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="menuGraficasTarjet">
                    <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                    <span>{{'financiero.razonesFinancieras.tooltipIcono3'|translate}}</span>
                  </button>
                  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarGraf(1)">
                    <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                    <span>{{'menu.Exportar' | translate}}</span>
                  </button>
                </mat-menu>
                <mat-menu #menuGraficasTarjet="matMenu">
                  <button  class="mat-menu-item"  [ngClass]="{'w3-disabled': tipoEvo === typeGraph.BAR}" [disabled]="tipoEvo == typeGraph.BAR"  mat-menu-item class="w3-caja-menu" (click)="changeGrafic3(typeGraph.BAR)">
                    <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                    <span>{{'financiero.razonesFinancieras.tooltipIcono4'|translate}}</span>
                  </button>
                  <button  class="mat-menu-item" [ngClass]="{'w3-disabled': tipoEvo === typeGraph.LINE}" [disabled]="tipoEvo == typeGraph.LINE" mat-menu-item class="w3-caja-menu" (click)="changeGrafic3(typeGraph.LINE)">
                    <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                    <span>{{'financiero.razonesFinancieras.tooltipIcono5'|translate}}</span>
                  </button>
                  <button  class="mat-menu-item" [ngClass]="{'w3-disabled': tipoEvo === typeGraph.AREA}" [disabled]="tipoEvo == typeGraph.AREA"  mat-menu-item class="w3-caja-menu" (click)="changeGrafic3(typeGraph.AREA)">
                    <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                    <span>{{'financiero.razonesFinancieras.tooltipIcono10'|translate}}</span>
                  </button>
                </mat-menu>
              </div>
            </div>
          </div>
          <div class="w3-row" style="height: 88%; background-color: white;">
            @if(dataGrafEvo.length > 0){
              <app-graficador 
                [etiquetas]="showLabelsEvo"
                [data]="dataGrafEvo"
                [labels]="etiquetasEvo"
                [type]="tipoEvo"
                [axisX]="'Periodos'"
                [axisY]="['']"
                [zona]="1"
                [colors]="color"
                [formatEtiquetas]="false"
                [legend]="{enabled: true, position: 'bottom'}"
                [animations]="true">                  
              </app-graficador>  
            }@else {<app-skeleton-grafica/>}            
          </div>
        </div>
      }
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modalOpen" (close)="modalOpen = false">
  <div modal-header>
    <div class="w3-row w3-white" style="width: 70vw;">
      <!--Titulo-->
      <div class="w3-setenta w3-titulo-contenidomenu padreizquierda">
        <div class="hijoizquierdaTitle" >
          @if (graf1) {
            <span class="w3-margin-left-contenido">{{'financiero.razonesFinancieras.tituloZona2Graf'|translate}} | {{ 'financiero.razonesFinancieras.tituloEncabezadoTabla2' | translate }}</span>
          }
          @if (graf2) {
            <span class="w3-margin-left-contenido">{{ indSeleccionado.descripcion }}</span>
          }
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitlesGraf)}}</span>
        </div>
      </div>
      <div class="w3-rest w3-right" style="height: 6vh;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          @if (graf2) {
            <mat-icon fontSet="material-icons-outlined" class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            (click)="showLabelsEvo = !showLabelsEvo" matTooltip="{{'financiero.razonesFinancieras.tooltipIcono0'|translate}}">
              {{ showLabelsEvo ? 'label_off' : 'label' }}
            </mat-icon>
          }
          <!-- Icono exportar -->
          <mat-icon class="w3-margin-right-contenido w3-button" [ngStyle]="{'color':'gray'}"
            (click)="exportarGraf(graf1 ? 0 : 1)" matTooltip="{{'menu.Exportar'|translate}}">
            image
          </mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div modal-body style="width: 70vw;">
    <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%;">
      <div class="w3-row contentGraf">
        @if (graf1) {
          <app-graficador 
            [etiquetas]="true"
            [data]="dataGraficas"
            [labels]="etiquetas"
            [type]="tipo"
            [axisX]="''"
            [axisY]="['']"
            [zona]="2"
            [colors]="colorSchemeSem"
            [formatEtiquetas]="false"
            [legend]="{enabled: false, position: 'bottom'}"
            [animations]="true"
            [hetamapValor]="true"
            (eventClick)="mostrarColores($event)">                  
          </app-graficador>
        }
        @if (graf2) {
          <app-graficador 
              [etiquetas]="showLabelsEvo"
              [data]="dataGrafEvo"
              [labels]="etiquetasEvo"
              [type]="tipoEvo"
              [axisX]="'Periodos'"
              [axisY]="['']"
              [zona]="3"
              [colors]="color"
              [formatEtiquetas]="false"
              [legend]="{enabled: true, position: 'bottom'}"
              [animations]="true">                  
            </app-graficador>
        
        }
      </div>
    </div>
  </div>  
</app-modal>